import FamlaServices from './FamlaServices';

import { toLocalSheetRefFromMapping, type LocalSheetRef } from '../../utils/mappingAccess';

export const buildBlankMappingPayload = (title: string) => ({
    swimlaneData: {
        id: 'main',
        type: '$swimlane',
        height: 600,
        width: 2000,
        header: { text: title },
        subHeaderRows: { headers: ['Role 1', 'Role 2', 'Role 3'] },
        lines: [],
    },
    blocks: [],
    groups: [],
});

/** Feuille locale prête pour navigation immédiate après PUT /mapping/new. */
export function toLocalSheetFromCreatedMapping(
    data: Record<string, unknown> | null | undefined,
    mapId: string,
): LocalSheetRef | null {
    if (!data || !mapId) return null;
    return toLocalSheetRefFromMapping({ ...data, _id: mapId, id: mapId });
}

export const createBlankMapping = async (
    processId: string,
    title: string,
    accessToken: string,
) =>
    FamlaServices(
        'api_host',
        `/mapping/new/${processId}?name=${encodeURIComponent(title)}`,
        'PUT',
        buildBlankMappingPayload(title),
        accessToken,
    );
